import { Button } from '@vlabs/uikit/components/controls/button';

import { filterIsApplied, FilterMenu } from '@vlabs/monokit/shared/ui/filter-menu';

import { useUserFiltersTranslation } from './i18n';
// eslint-disable-next-line import-x/no-namespace
import * as SideMenu from './side-menu';
import { useUserListFilters } from './useUserListPageFilters';

function UserListFilterMenu(): JSX.Element {
  const { t } = useUserFiltersTranslation();
  const { filters, setFilters } = useUserListFilters();

  const isResetDisabled = Object.values(filters).filter(Boolean).length === 0;

  return (
    <FilterMenu
      filters={[
        <SideMenu.UserRoleFilterWithLeftPopover
          badge={filterIsApplied(!!filters.role_id)}
          key="role_id"
          value={t('role_id.label')}
        />,
        <SideMenu.DepartmentFilterWithLeftPopover
          badge={filterIsApplied(!!filters.department_id)}
          key="department_id"
          value={t('department_id.label')}
        />,
        <SideMenu.LastLoginDateFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.last_login_at__lt ?? filters.last_login_at__gte))}
          key="last_login_at"
          value={t('last_login_at.label')}
        />,
        <SideMenu.UserNameFilterWithLeftPopover
          badge={filterIsApplied(!!filters.full_name)}
          key="full_name"
          value={t('full_name.label')}
        />,
        <SideMenu.UserEmailFilterWithLeftPopover
          badge={filterIsApplied(!!filters.email)}
          key="email"
          value={t('email.label')}
        />,
        <SideMenu.UserIdFilterWithLeftPopover
          badge={filterIsApplied(!!filters.user_ids)}
          key="user_id"
          value={t('user_id.label')}
        />,
        <SideMenu.DateCreatedFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.create_time__gte ?? filters.create_time__lt))}
          key="create_time"
          value={t('create_time.label')}
        />,
      ]}
      footer={(
        <Button
          data-testid="button.reset-permission-tags-filters"
          disabled={isResetDisabled}
          fullWidth
          kind="negative"
          onClick={() => setFilters({
            page: 0,
            page_size: 25,
          })}
        >
          {t('reset')}
        </Button>
      )}
    />
  );
}

export { UserListFilterMenu };
